module.exports = __webpack_public_path__ + "img/04.1f83ea9d.jpg";